import { useSignal } from '@preact/signals';
import { useEffect } from 'react';

const MOBILE_BREAKPOINT = 481;
const TABLET_BREAKPOINT = 768;
const DESKTOP_BREAKPOINT = 1201;

export const useScreen = () => {
  const width = useSignal(window.innerWidth);

  const handleWindowSizeChange = () => {
    width.value = window.innerWidth;
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  const isMobile = width.value < MOBILE_BREAKPOINT;
  const isTablet = width.value < TABLET_BREAKPOINT;
  const isDesktop = width.value > DESKTOP_BREAKPOINT;

  return { isMobile, isTablet, isDesktop };
};
